export default __webpack_public_path__ + "static/media/employee.57fad731.png";